import { Card, CardBody, CardHeader } from '@heroui/react';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { validateEntry } from '@/patient-app-common/helpers/progress_helper';
import { getImageNumber } from '@/patient-app-common/helpers/survey_helper';

export function TrackerEntry({ entry, survey }) {
  if (!entry || !survey) {
    return null;
  }

  const { questions } = survey;
  const { source } = entry;

  return (
    <div className="flex flex-col gap-4">
      {questions.map((question) => {
        const hasAnswer = _.has(source, question.id);
        if (!hasAnswer) return null;

        const answer = source[question.id];
        const isValid = validateEntry(question, answer);
        if (!isValid) return null;

        return (
          <Card key={question.id} shadow="sm">
            <CardHeader>
              <h3 className="pb-2">{question.title}</h3>
            </CardHeader>
            <CardBody>
              <AnswerFragment question={question} answer={answer} />
            </CardBody>
          </Card>
        );
      })}
    </div>
  );
}

function AnswerFragment({ question, answer }) {
  const { t } = useTranslation('survey');

  switch (question.type) {
    case 'camera':
      if (!answer) {
        return <p>{t('common.text.no_entry')}</p>;
      }
      return <img alt="" src={answer} width="150px" />;

    case 'checkbox': {
      const selectedList = _.filter(
        question.answers,
        (_checkbox, i) => answer[i]
      );
      const labels = _.map(selectedList, 'text');
      const list = labels.map((label) => <li key={label}>{label}</li>);

      return <ol className="list-disc ml-4">{list}</ol>;
    }

    case 'device':
      break;

    case 'face_scale':
      return <p>{t(`facescale.value_${answer * 2}`)}</p>;

    case 'gen_scale':
    case 'radio':
      return <p>{question.answers[answer]?.text}</p>;

    case 'medicine': {
      const list = answer.map((value, i) => {
        if (!_.isEmpty(value)) {
          return (
            <li key={question.answers[i].text}>
              {`${question.answers[i].text} ${value.dose} - ${value.pills} pills`}
            </li>
          );
        }
        return '';
      });
      return <ol className="list-disc ml-4">{list}</ol>;
    }

    case 'multiple_numerical_input': {
      let text = t('common.text.no_entry');

      if (_.isArray(answer)) {
        text = `${answer.join('/')} ${question.options.unit || ''}`;
      }

      return <p>{text}</p>;
    }

    case 'picker':
      return <p>{getImageNumber(question.answers[answer]?.text)}</p>;

    default:
      return <p>{answer || t('common.text.no_entry')}</p>;
  }
}
